import React from "react";
import { Card, FilterBar, SearchBar, Switch } from "@sscs/ui";
import { FilterGroups } from "../../types";

type FiltersAndActionsProps = {
  filter: FilterGroups;
  found: React.ComponentProps<typeof Card.Filters>["found"];
  onFilterChange: (filter: FilterGroups) => void;
};

const GroupsFiltersAndActions = ({
  filter,
  found,
  onFilterChange,
}: FiltersAndActionsProps): React.JSX.Element => {
  return (
    <Card.Filters found={found}>
      <FilterBar
        filters={[
          {
            id: "name",
            control: (
              <SearchBar
                id="search-group-name"
                value={filter.name ?? ""}
                onChange={(value) => onFilterChange({ ...filter, name: value })}
                variant="outlined"
                label="Search for group name"
                slotProps={{ htmlInput: { maxLength: 256 } }}
                debounceTimer={250}
              />
            ),
          },
          {
            id: "has-limit",
            fit: true,
            control: (
              <Switch
                title="Filter groups"
                label="Limited only"
                checked={filter.hasLimit === "true"}
                onChange={(event) =>
                  onFilterChange({
                    ...filter,
                    hasLimit: event.target.checked ? "true" : "false",
                  })
                }
              />
            ),
          },
        ]}
      />
    </Card.Filters>
  );
};

export default GroupsFiltersAndActions;
